/** After email confirmation, browser reads this from localStorage (avoids huge Supabase redirect_to URLs). */
export const PANDA_POST_AUTH_REDIRECT_KEY = "panda_post_auth_redirect";

export const PANDA_POST_AUTH_REDIRECT_TTL_MS = 60 * 60 * 1000;

export function savePostAuthRedirect(path: string): void {
  if (typeof window === "undefined") return;
  try {
    localStorage.setItem(
      PANDA_POST_AUTH_REDIRECT_KEY,
      JSON.stringify({
        path,
        exp: Date.now() + PANDA_POST_AUTH_REDIRECT_TTL_MS,
      }),
    );
  } catch {
    // storage full or unavailable
  }
}
